import { render } from "./accountTitle.vue?vue&type=template&id=71fa9d2e&scoped=true"
import script from "./accountTitle.vue?vue&type=script&lang=js"
export * from "./accountTitle.vue?vue&type=script&lang=js"

import "./accountTitle.vue?vue&type=style&index=0&id=71fa9d2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71fa9d2e"

export default script